/* Nonvisual fixes for the app markup identified in the October 2026 scan.
 * Rebuy owns visibility/focus trapping; this adapter only excludes its closed cart.
 * Shopify chat owns its open shadow DOM; only the unnamed-role indicator is patched.
 */
(function () {
  'use strict';

  var observedRoots = new WeakSet();
  var observedCarts = new WeakSet();
  var managedInert = new WeakSet();
  var chatHosts = 'shopify-chat, shopify-agent-runtime';

  function releaseCart(cart) {
    if (managedInert.has(cart)) {
      cart.removeAttribute('inert');
      managedInert.delete(cart);
    }
  }

  function syncCart(cart) {
    if (cart.getAttribute('aria-hidden') === 'true') {
      if (!cart.hasAttribute('inert')) {
        cart.setAttribute('inert', '');
        managedInert.add(cart);
      }
    } else {
      releaseCart(cart);
    }
  }

  function bindCart(cart) {
    if (!observedCarts.has(cart)) {
      observedCarts.add(cart);
      new MutationObserver(function () { syncCart(cart); }).observe(cart, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
    syncCart(cart);
  }

  function labelChatIndicator(element) {
    if (element.matches('span.activator__indicator[aria-label]') &&
        (!element.hasAttribute('role') || element.getAttribute('role') === 'generic')) {
      element.setAttribute('role', 'img');
    }
  }

  function inspect(element, inChat) {
    if (element.nodeType !== 1) return;
    if (!inChat && element.id === 'rebuy-cart') bindCart(element);
    if (inChat) labelChatIndicator(element);
    if (element.matches(chatHosts) && element.shadowRoot) {
      observeRoot(element.shadowRoot, true);
    }
  }

  function scan(root, inChat) {
    inspect(root, inChat);
    var selector = inChat ? chatHosts + ', span.activator__indicator[aria-label]' : chatHosts + ', #rebuy-cart';
    root.querySelectorAll(selector).forEach(function (element) { inspect(element, inChat); });
  }

  function observeRoot(root, inChat) {
    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'attributes') {
            inspect(record.target, inChat);
          } else {
            record.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) scan(node, inChat);
            });
          }
        });
      }).observe(root, inChat ? {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label', 'role']
      } : { childList: true, subtree: true });
    }
    scan(root, inChat);
  }

  observeRoot(document, false);

  // Defined custom elements upgrade existing hosts before these callbacks run.
  // This also covers a widget whose open shadow roots are created after theme load.
  if (window.customElements) {
    ['shopify-chat', 'shopify-agent-runtime'].forEach(function (name) {
      customElements.whenDefined(name).then(function () { scan(document, false); });
    });
  }

  document.addEventListener('rebuy:smartcart.ready', function () { scan(document, false); });
  document.addEventListener('rebuy:smartcart.show', function () {
    var cart = document.getElementById('rebuy-cart');
    // The documented synchronous show event lets Rebuy focus its opening dialog.
    // The aria-hidden observer handles subsequent open/close state rendering.
    if (cart) releaseCart(cart);
  });
}());
